const FaceTecStrings = {
  FaceTec_accessibility_cancel_button: "Cancelar",

  FaceTec_feedback_center_face: "Centralize Seu Rosto",
  FaceTec_feedback_face_not_found: "Enquadre o Seu Rosto",
  FaceTec_feedback_move_phone_away: "Afaste-se",
  FaceTec_feedback_move_away_web: "Afaste-se",
  FaceTec_feedback_move_phone_closer: "Aproxime-se",
  FaceTec_feedback_move_phone_to_eye_level: "Telefone ao Nível dos Olhos",
  FaceTec_feedback_move_to_eye_level_web: "Olhe Para a Câmera",
  FaceTec_feedback_face_not_looking_straight_ahead: "Olhe Para Frente",
  FaceTec_feedback_face_not_upright: "Mantenha a Cabeça Reta",
  FaceTec_feedback_face_not_upright_mobile: "Mantenha a Cabeça Reta",
  FaceTec_feedback_hold_steady: "Segure Firme",
  FaceTec_feedback_move_web_closer: "Aproxime-se",
  FaceTec_feedback_move_web_even_closer: "Mais Próximo",
  FaceTec_feedback_use_even_lighting: "Ilumine Seu Rosto Uniformemente",

  FaceTec_instructions_header_ready_desktop:
    "Prepare-se para sua foto",
  FaceTec_instructions_header_ready_1_mobile: "Prepare-se para",
  FaceTec_instructions_header_ready_2_mobile: "Sua Foto",
  FaceTec_instructions_message_ready_desktop:
    "Enquadre seu rosto dentro da linha de marcação",
  FaceTec_instructions_message_ready_1_mobile: "Enquadre seu rosto dentro da linha de marcação,",
  FaceTec_instructions_message_ready_2_mobile:
    "clique em Estou Pronto e siga as instruções",

  FaceTec_action_im_ready: "ESTOU PRONTO",
  FaceTec_presession_frame_your_face: "Enquadre seu rosto no oval",
  FaceTec_presession_look_straight_ahead: "Olhe para frente",
  FaceTec_presession_hold_steady3: "Segure firme por: 3",
  FaceTec_presession_hold_steady2: "Segure firme por: 2",
  FaceTec_presession_hold_steady1: "Segure firme por: 1",
  FaceTec_presession_eyes_straight_ahead: "Olhe para frente",
  FaceTec_presession_remove_dark_glasses: "Remover óculos escuros",
  FaceTec_presession_neutral_expression: "Expressão neutra, sem sorriso",
  FaceTec_presession_conditions_too_bright: "Condições muito claras",
  FaceTec_presession_brighten_your_environment: "Ilumine seu ambiente",

  FaceTec_result_facescan_upload_message:
    "Upload<br/>Criptografado<br/>do FaceScan 3D",
  FaceTec_result_idscan_upload_message:
    "Upload<br/>Criptografado<br/>do Documento",

  FaceTec_retry_header: "Vamos Tentar Novamente",
  FaceTec_retry_subheader_message:
    "",
  FaceTec_retry_your_image_label: "Sua selfie",
  FaceTec_retry_ideal_image_label: "Pose Ideal",
  FaceTec_retry_instruction_message_1: "Expressão Neutra, Sem Sorrir",
  FaceTec_retry_instruction_message_2: "Sem Reflexo ou Iluminação Extrema",
  FaceTec_retry_instruction_message_3: "Muito borrado, limpe sua câmera",
  FaceTec_action_try_again: "TENTE NOVAMENTE",

  FaceTec_camera_feed_issue_header:
    "<b>Problema ao criptografar o feed da câmera</b>",
  FaceTec_camera_feed_issue_subheader_message:
    "Este sistema não pode ser verificado devido ao seguinte:",
  FaceTec_camera_feed_issue_table_header_1: "Possível problema",
  FaceTec_camera_feed_issue_table_header_2: "Fixar",
  FaceTec_camera_feed_issue_table_row_1_cell_1_firefox_permissions_error:
    "Permissões da câmera não lembradas no Firefox.",
  FaceTec_camera_feed_issue_table_row_1_cell_2_firefox_permissions_error:
    "Verifique Lembrar permissões.",
  FaceTec_camera_feed_issue_table_row_1_cell_1:
    "Câmera já em uso por outro App.",
  FaceTec_camera_feed_issue_table_row_1_cell_2: "Feche o outro aplicativo.",
  FaceTec_camera_feed_issue_table_row_2_cell_1:
    "Um aplicativo de terceiros está modificando o vídeo.",
  FaceTec_camera_feed_issue_table_row_2_cell_2:
    "Feche/desinstale o outro aplicativo.",
  FaceTec_camera_feed_issue_table_row_3_cell_1:
    "Hardware não capaz de ser protegido.",
  FaceTec_camera_feed_issue_table_row_3_cell_2: "Use um dispositivo diferente.",
  FaceTec_camera_feed_issue_subtable_message:
    "Este aplicativo bloqueia configurações suspeitas de webcam. <a href='https://livenesscheckhelp.com/' target='_blank' style='text-decoration:underline;'>Saiba mais aqui</a>.",
  FaceTec_camera_feed_issue_action: "Tente novamente mesmo assim",
  FaceTec_camera_feed_issue_action_firefox_permissions_error: "OK",

  FaceTec_camera_permission_header: "Ativar Câmera",
  FaceTec_camera_permission_message:
    "O acesso à câmera está desativado. Toque abaixo para ativar em ajustes.",
  FaceTec_action_ok: "OK",

  FaceTec_enter_fullscreen_header: "Modo selfie em tela cheia",
  FaceTec_enter_fullscreen_message:
    "Antes de começarmos, clique no botão abaixo para abrir o modo de tela cheia",
  FaceTec_enter_fullscreen_action: "Abrir tela cheia",

  FaceTec_initializing_camera: "Iniciando a Câmera...",
  FaceTec_initializing_camera_still_loading:
    "Criptografando o feed da câmera...",

  FaceTec_idscan_type_selection_header: "Tipo do Documento",
  FaceTec_action_select_id_card: "Documento Com Foto",
  FaceTec_action_select_passport: "PASSAPORTE",
  FaceTec_idscan_capture_id_card_front_instruction_message:
    "Mostre a Frente do Documento Com Foto",
  FaceTec_idscan_capture_id_card_back_instruction_message:
    "Mostre o Verso do Documento",
  FaceTec_idscan_capture_passport_instruction_message:
    "Mostre a Página da Foto no Passaporte",
  FaceTec_action_take_photo: "TIRAR FOTO",
  FaceTec_idscan_review_id_card_front_instruction_message:
    "Confirme Se a Foto Está Clara e Legível",
  FaceTec_idscan_review_id_card_back_instruction_message:
    "Confirme Se Está Claro e Legível",
  FaceTec_idscan_review_passport_instruction_message:
    "Confirme Se a Foto Está Clara e Legível",
  FaceTec_action_accept_photo: "ACEITAR",
  FaceTec_action_retake_photo: "RECAPTURAR",

  FaceTec_result_idscan_unsuccess_message:
    "Foto do Documento Nāo Corresponde com Rosto do Usuário",

  FaceTec_result_success_message: "Sucesso!",
};

module.exports = FaceTecStrings;
